import { FormControl, Radio } from "@mui/material";
import { t } from "i18next";
import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

import { DatasetModal } from "../DatasetModal";

import {
  RadioGroup,
  FormControlLabel,
  Box,
  Button,
  Typography,
  Tooltip,
} from "@components/base";

interface FooterSelectDataSet {
  isUserViewedContent: boolean;
}

const FooterSelectDataSet: FC<FooterSelectDataSet> = ({ isUserViewedContent }) => {
  const navigate = useNavigate();
  const [selectedDataset, setSelectedDataset] = useState<string | null>(null);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const handleDatasetChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSelectedDataset(event.target.value);
  };

  const handleDecideLater = (): void => {
    navigate("/csob");
  };

  const color = !isUserViewedContent ? "textDisabled" : "textPrimary";

  return (
    <Box height="55px" position="relative" marginLeft={-3} marginRight={-3}>
      <Box
        position="absolute"
        top={0}
        left={0}
        width="100%"
        zIndex={1}
        boxShadow=" 0px -3px 10px 0px #6B6B6B26"
      >
        <Box padding={2}>
          <Box
            display="flex"
            alignItems="center"
            gap={2}
            justifyContent="space-between"
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Typography fontWeight={500} color={color}>
                {t("csob.datasetComparison.conditionBar.placeholder")}
              </Typography>
              <Tooltip
                disableHoverListener={isUserViewedContent}
                disableFocusListener={isUserViewedContent}
                disableTouchListener={isUserViewedContent}
                title={t("csob.datasetComparison.conditionBar.tooltip")}
                arrow
              >
                <FormControl>
                  <RadioGroup
                    row
                    value={selectedDataset}
                    onChange={handleDatasetChange}
                  >
                    <FormControlLabel
                      value="csob"
                      control={
                        <Radio color="primary" disabled={!isUserViewedContent} />
                      }
                      label={
                        <Typography fontWeight={500} color={color}>
                          {t("csob.datasetComparison.conditionBar.option1")}
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="greenometer"
                      control={
                        <Radio color="primary" disabled={!isUserViewedContent} />
                      }
                      label={
                        <Typography fontWeight={500} color={color}>
                          {t("csob.datasetComparison.conditionBar.option2")}
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </FormControl>
              </Tooltip>
            </Box>
            <Box>
              <Box display="flex" gap={2}>
                <Button variant="outlined" size="medium" onClick={handleDecideLater}>
                  {t("csob.datasetComparison.conditionBar.buttonSecondary")}
                </Button>
                <Button
                  size="medium"
                  disabled={!selectedDataset}
                  onClick={() => {
                    setIsVisibleModal(true);
                  }}
                >
                  {t("csob.datasetComparison.conditionBar.buttonPrimary")}
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
        <DatasetModal
          handleCloseModal={() => setIsVisibleModal(false)}
          isVisibleModal={isVisibleModal}
          datasetIndex={selectedDataset === "csob" ? 1 : 2}
        />
      </Box>
    </Box>
  );
};

export default FooterSelectDataSet;
